module.exports = __webpack_public_path__ + "img/7minutos4.48a3dcd6.jpg";